import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { CreateQuestion, ModifyQuestion, UserQNARepository } from './domain/UserQNARepository'

import { QNA } from '../../contracts/service-offer'
import {
  AxiosErrorHandler,
  PaginationCriteria,
  SupernovaPagedBody,
  SupernovaPagedResponse,
  SupernovaResponse,
} from '../../foundation'

export class UserApiQNAList implements UserQNARepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getList = async (criteria: PaginationCriteria<{ serviceOfferId: number }>): Promise<SupernovaPagedBody<QNA[]>> => {
    const config: AxiosRequestConfig<PaginationCriteria<{ serviceOfferId: number }>> = {
      url: '/service-offer/qna/queries/user/get-questions-and-answers/process',
      method: 'post',
      data: criteria,
    }

    try {
      const { data } = await this.axios.request<SupernovaPagedResponse<QNA[]>>(config)
      return data.body
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  create = async (command: CreateQuestion): Promise<{ serviceOfferId: number; questionId: number }> => {
    const config: AxiosRequestConfig<CreateQuestion> = {
      url: '/service-offer/qna/commands/user/create-question/execute',
      method: 'post',
      data: command,
    }

    try {
      const { data } =
        await this.axios.request<SupernovaResponse<{ serviceOfferId: number; questionId: number }>>(config)
      return data.body
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  modify = async (command: ModifyQuestion): Promise<{ serviceOfferId: number; questionId: number }> => {
    const config: AxiosRequestConfig<ModifyQuestion> = {
      url: '/service-offer/qna/commands/user/modify-question/execute',
      method: 'post',
      data: command,
    }

    try {
      const { data } =
        await this.axios.request<SupernovaResponse<{ serviceOfferId: number; questionId: number }>>(config)
      return data.body
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  remove = async (questionId: number): Promise<void> => {
    const config: AxiosRequestConfig<{ questionId: number }> = {
      url: '/service-offer/qna/commands/user/remove-question/execute',
      method: 'post',
      data: { questionId },
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
